<template>
  <div class="material-circle" :style="{ height: containerHeight + 'px' }">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已加载全部内容"
        @load="onLoadMore"
      >
        <material-waterfall
          :list="materialList"
          @click="onItemClick"
          @like="onLikeClick"
        />
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import MaterialWaterfall from "./MaterialWaterfall.vue";
import { homeMaterial } from "@/api/home";

export default {
  name: "MaterialCircle",
  components: {
    MaterialWaterfall
  },
  props: {
    containerHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      materialList: [],
      refreshing: false,
      loading: false,
      finished: false,
      page: {
        pageNo: 1,
        pageSize: 10
      },
      lastScrollTop: 0
    };
  },
  methods: {
    async loadMaterial(isRefresh = false) {
      if (isRefresh) {
        this.page.pageNo = 1;
      }
      try {
        const res = await homeMaterial(this.page);
        let newItems = [];
        let hasNextPage = false;
        if (res && res.code === 1 && res.data) {
          newItems = res.data.rows || [];
          hasNextPage = res.data.hasNextPage !== false;
        }
        if (isRefresh) {
          this.materialList = newItems;
        } else {
          this.materialList = [...this.materialList, ...newItems];
        }
        if (!hasNextPage || newItems.length < this.page.pageSize) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("加载素材失败", err);
        this.finished = true;
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },
    onRefresh() {
      this.finished = false;
      this.refreshing = true;
      this.loadMaterial(true);
    },
    onLoadMore() {
      if (this.refreshing) return;
      if (this.materialList.length === 0) {
        this.loadMaterial(true);
        return;
      }
      this.page.pageNo++;
      this.loadMaterial(false);
    },
    onItemClick(item) {
      if (item && item.id) {
        this.$router.push({
          path: "/material/detail",
          query: { id: item.id }
        });
      }
    },
    onLikeClick(item) {
      // 模拟点赞
      item.isCollected = !item.isCollected;
      if (item.isCollected) {
        item.collectSum = (item.collectSum || 0) + 1;
        this.$toast("点赞成功");
      } else {
        item.collectSum = Math.max(0, (item.collectSum || 0) - 1);
        this.$toast("取消点赞");
      }
    },
    handleScroll() {
      this.lastScrollTop = this.$el.scrollTop;
    }
  },
  activated() {
    this.$el.addEventListener("scroll", this.handleScroll);
    if (this.lastScrollTop) {
      this.$nextTick(() => {
        this.$el.scrollTop = this.lastScrollTop;
      });
    }
  },
  deactivated() {
    this.$el.removeEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    this.$el.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.material-circle {
  width: 100%;
  overflow-y: auto;
  background-color: #f7f8fa;
  -webkit-overflow-scrolling: touch;
}
</style>
